import React from "react";

import { CategoryContextProvider } from "../../../../Components/GMS/Category/CategoryContext";
import CategoryTypeManage from "../../../../Components/GMS/Category/Manage";

function CategoryManage(props) {
  return (
    <React.Fragment>
      <CategoryContextProvider>
        <CategoryTypeManage props={props} />
      </CategoryContextProvider>
    </React.Fragment>
  );
}

export default CategoryManage;
